<div>
  <h1 mat-dialog-title>{{confirmMessage}}</h1>
  <mat-dialog-actions>
    <div class="actions-wrapper">
      <button mat-raised-button class="btn btn-green" (click)="dialogRef.close(true)">
        Confirm
      </button>
      <button mat-raised-button class="btn btn-red" (click)="dialogRef.close(false)">
        Cancel
      </button>
    </div>
  </mat-dialog-actions>
</div>
